import { useEffect, useState } from "react";
import { API_BASE_URL, fetchWithTimeout } from "../lib/api";
import { WhatsNewRelease } from "../data/whats-new";

/**
 * Loads published "What's New" entries (ENG-2724: `GET /release-notes/published`, backed by the
 * release_notes table — editable via the Haven Admin MCP, no deploy required). Public endpoint —
 * a plain fetch, not `authenticatedFetch`, since both the passive Home feed and the post-update
 * view (`?postupdate&version=…`) need it before there's any guarantee of a signed-in Firebase user.
 */
export const useWhatsNew = () => {
  const [releases, setReleases] = useState<WhatsNewRelease[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const response = await fetchWithTimeout(`${API_BASE_URL}/release-notes/published`);
        if (!response.ok) return;
        const data = (await response.json()) as WhatsNewRelease[];
        if (!cancelled) setReleases(data);
      } catch {
        // Best-effort: a failed fetch leaves releases empty — the passive feed renders
        // nothing and the post-update view falls through to Home, same as an unauthored version.
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { releases, loading };
};
